import styled, { css } from 'styled-components'
import FlexRow from '../FlexRow'
import Segment from '../Segment'
import { EditableText } from '..'

export const UploadLabel = styled.label`
  &&&&& {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    cursor: pointer;
  }
`

export const UploadInput = styled.input`
  display: none;
`

export const AcceptedFileTypesLabel = styled.div`
  display: inline-block;
  font-size: 12px;
  font-style: italic;
  margin-top: 4px;
  cursor: pointer;
`

export const AcceptedFileTypes = styled.ul`
  max-height: 200px;
  overflow: auto;

  li {
    margin: 0;
  }
`

export const FileRow = styled(FlexRow)`
  align-items: center;
  border: 1px solid #bdcbd0;
  border-radius: 3px;
  height: 50px;
  width: 400px;
  max-width: 100%;
  overflow: hidden;
`

export const FileRowWrapper = styled(Segment).attrs({
  basic: true,
})`
  display: flex;
  flex-direction: column;
  ${FlexRow}:last-child {
    margin-bottom: 0;
  }
`

export const FileIconWrapper = styled(({ disabled, ...rest }) => (
  <FlexRow.Section {...rest} />
))`
  ${({ disabled }) => css`
    background: #fbf2f2;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    padding: calc(0.5em + 2px);
    flex-grow: 0;
    cursor: ${disabled ? 'default' : 'pointer'};
  `}
`

export const FileName = styled(FlexRow.Section)`
  ${({ isEditable }) => css`
    justify-content: space-between;
    margin-left: 1em;
    overflow: hidden;
    ${!isEditable &&
    css`
      span {
        padding-right: 0.5em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `}
  `}
`
export const EditableFileName = styled(EditableText)`
  // If you are wondering about the min-width: https://css-tricks.com/flexbox-truncated-text/
  display: flex;
  flex: 1;
  min-width: 0;
  > span {
    display: flex;
    flex: 1;
    padding-right: 5px;
    min-width: 0;
    span {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`
export const DeleteIconWrapper = styled(FlexRow.Section)`
  flex-grow: 0;
  padding: 1em;

  i.icon {
    cursor: pointer;
    position: relative;
    top: -2px;
  }
`
